import { Component, OnInit } from "@angular/core";
import {
  EmailValidator,
  FormGroup,
  FormControl,
  Validators
} from "@angular/forms";
import {
  AngularFirestore,
  AngularFirestoreCollection
} from "angularfire2/firestore";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"]
})
export class FooterComponent implements OnInit {
  formSubmitted: boolean = false;

  emailCollection: AngularFirestoreCollection<any> = this.db.collection(
    "subscribers"
  );

  email: object = {
    email: "",
    createdAt: Date
  };

  constructor(private db: AngularFirestore) {}

  ngOnInit() {}

  subscribeEmail(email) {
    console.log(email);
    email.createdAt = new Date();
    this.formSubmitted = true;
    this.emailCollection.add(email);
  }
}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/footer/footer.component.ts